var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentIconJcbColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.58 21H2.42A2.4 2.4 0 010 18.62V4.38A2.4 2.4 0 012.42 2h24.16A2.4 2.4 0 0129 4.38v14.25A2.4 2.4 0 0126.58 21z",
    fill: "#EBF1F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19h4c.91 0 2-1.12 2-2V4H7c-.91 0-2 1.12-2 3v12z",
    fill: "#047AB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27 14.14A8.2 8.2 0 015 13.82v-1.1a3.9 3.9 0 001.9.58c.77 0 1.2-.54 1.2-1.28V9H10v3.02c0 1.18-.62 2.12-2.73 2.12z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19h4c.91 0 2-1.12 2-2V4h-4c-.91 0-2 1.12-2 3v12z",
    fill: "#D42D06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.7c.58-.56 1.58-.91 3.2-.83.88.04 1.8.3 1.8.3v1.11a4.07 4.07 0 00-1.73-.57c-1.23-.11-1.98.58-1.98 1.79s.75 1.9 1.98 1.8a4.13 4.13 0 001.73-.58v1.1s-.92.27-1.8.31c-1.62.08-2.62-.27-3.2-.83V9.7z",
    fill: "#FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19h4c.91 0 2-1.12 2-2V4h-4c-.91 0-2 1.12-2 3v12z",
    fill: "#67B637"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.7c0 .8-.62 1.3-1.45 1.3H19V9h3.23l.23.01c.73.04 1.27.47 1.27 1.21 0 .58-.37 1.08-1.04 1.2v.03c.74.05 1.31.52 1.31 1.25zm-2.55-2.91a.91.91 0 00-.13-.01h-1.2v1.26h1.33c.25-.06.46-.29.46-.63s-.21-.57-.46-.62zm.15 2.04a.86.86 0 00-.16-.01h-1.32v1.37h1.32l.16-.02c.25-.06.46-.32.46-.67 0-.35-.2-.6-.46-.67z",
    fill: "#FFF"
  })));
}

export default SvgPaymentIconJcbColor;